/// <reference path="../assets.d.ts" />
import type { ReactNode } from 'react';
import './login-shell.css';
import loginVisual from './login-visual.svg';

export interface LoginShellProps {
  /** Tenant's own name once known; falls back to the product name. */
  readonly productName?: string;
  readonly productTagline?: string;
  /** Tenant logo URL. The generic bar mark is used when there is none. */
  readonly logoUrl?: string | null;
  readonly eyebrow?: string;
  readonly title: string;
  readonly subtitle?: string;
  readonly footerText?: string;
  readonly children: ReactNode;
}

/**
 * The sign-in page frame every app renders: admin (tenant admin, branding and
 * sales officers), vendor portal and field force all land here, so the
 * experience is identical whoever is signing in.
 */
export function LoginShell({
  productName = 'Brand Operations',
  productTagline = 'Management System',
  logoUrl,
  eyebrow = 'SECURE WORKSPACE',
  title,
  subtitle,
  footerText = 'Protected enterprise access',
  children,
}: LoginShellProps): ReactNode {
  return (
    <div className="login-shell">
      <div className="login-shell__visual" aria-hidden="true">
        <img src={loginVisual} alt="" />
      </div>

      <section className="login-panel">
        <div className="login-panel__inner">
          <header className="login-mark">
            <span className="login-mark__icon" aria-hidden="true">
              {logoUrl ? <img src={logoUrl} alt="" /> : <><i /><i /><i /></>}
            </span>
            <span>
              <strong>{productName}</strong>
              <small>{productTagline}</small>
            </span>
          </header>

          <div className="login-heading">
            <p className="login-heading__eyebrow">{eyebrow}</p>
            <h1>{title}</h1>
            {subtitle ? <p className="login-heading__sub">{subtitle}</p> : null}
          </div>

          {children}

          <footer className="login-footer">
            <span className="login-footer__dot" aria-hidden="true" />
            {footerText}
          </footer>
        </div>
      </section>
    </div>
  );
}
